<template lang="pug">
    div.markets

        div.marketsHeader

            // Title
            title-component(type="h3" title="Data")

        div.marketsContent

            // Api Key
            v-text-field(
                v-if="apiKey"
                id="apiKey"
                :label="$t('fields.cardNumber')"
                append-icon="content_copy"
                @click:append="copyApiKey"
                :value="apiKey"
                outlined
                hide-details
            )

            v-alert(
                v-else
                border="bottom"
                color="primary"
                elevation="2"
                type="info"
            ) {{ $t('config.alertMessage') }}
</template>

<script>
    import { Title, Separator } from '~components';
    import { config } from '~api';
    import { mapActions } from 'vuex';

    export default {
        components: {
            TitleComponent: Title,
            SeparatorComponent: Separator,
        },
        data() {
            return {
                apiKey: '',
            };
        },
        async created() {
            const resp = await config.getApiKey();

            if (resp.ok) this.apiKey = resp.data;
        },
        methods: {
            ...mapActions('snackbar', ['showMessage']),
            /**
             * Copy Api Key
             */
            copyApiKey() {
                try {
                    document.querySelector('#apiKey').select();
                    document.execCommand('copy');
                    this.showMessage(this.$t('config.copySuccessMessage'));
                } catch (e) {
                    this.showMessage(e);
                }
            },
        },
    };
</script>

<style lang="stylus" scoped>
    .marketsHeader
        display: flex
        align-items: center
        justify-content: space-between
</style>
